import {styled} from '@mui/material'
import {Texts} from 'appearance'
import Button from 'components/Control/Button'
import Dialog from 'components/Display/Dialog/Dialog'
import {useState} from 'react'
import {useI18n} from 'store/Store'

const PickSubscription = ({currentSubscription, subscriptions}) => {
    const {i18n} = useI18n()
    const [open, setOpen] = useState(false)

    const toggleConfirmationDialog = () => {
        setOpen(!open)
    }

    const mockSubscriptions = [
        {
            subscriptionName: 'X',
            subscriptionPrice: 230,
            reportPrice: 40,
        },
        {
            subscriptionName: 'Y',
            subscriptionPrice: 300,
            reportPrice: 20,
        },
        {
            subscriptionName: 'Z',
            subscriptionPrice: 210,
            reportPrice: 25,
        },
    ]

    const titles = Object.keys(mockSubscriptions[0])

    return (
        <Container>
            <CurrentSubscription>
                {i18n.t(`settings.currentSubscriptionTitle`, {
                    subscription: currentSubscription,
                })}
            </CurrentSubscription>
            <Subscriptions>
                {titles.map((title, index) => (
                    <SubscriptionRow key={title}>
                        <Text bold={true}>
                            {i18n.t(`settings.${title}`, {name: ''})}
                        </Text>
                        {mockSubscriptions.map((subscription) => (
                            <Text>
                                {`${subscription[title]}${
                                    index === 0 ? '' : '₪'
                                }`}
                            </Text>
                        ))}
                    </SubscriptionRow>
                ))}
            </Subscriptions>
            <ButtonWrapper>
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={toggleConfirmationDialog}>
                    {i18n.t('form.save')}
                </Button>
            </ButtonWrapper>
            <Dialog
                title=""
                cancelButtonText={i18n.t('form.goBack')}
                open={open}
                handleClose={toggleConfirmationDialog}
                //TODO: handle change subscription when API is ready
                handleSave={toggleConfirmationDialog}>
                <ConfirmationText>
                    {i18n.t('settings.confirmChangeSubscriptionText')}
                </ConfirmationText>
            </Dialog>
        </Container>
    )
}

export default PickSubscription

const Container = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 24px;
`

const CurrentSubscription = styled(Texts.BoldText)``

const Subscriptions = styled('div')`
    display: flex;
`

const SubscriptionRow = styled('div')`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    gap: 8px;
`

const Text = styled(Texts.RegularText)`
    font-weight: ${({bold}) => (bold ? 'bold' : 'normal')};
`

const ButtonWrapper = styled('div')`
    display: flex;
    justify-content: flex-end;
`

const ConfirmationText = styled(Texts.RegularText)`
    padding: 12px;
    font-size: 18px;
`
